<template>
  <svg viewBox="0 0 600 600" :class="{ active: changeColor }">
    <rect x="137.15" y="285.21" width="43.32" height="225.81" rx="15.63" ry="15.63" />
    <rect x="136.9" y="180.8" width="43.32" height="93.42" rx="15.12" ry="15.12" />
    <rect x="231.28" y="392.31" width="43.32" height="118.7" rx="14.76" ry="14.76" />
    <rect x="231.19" y="101.55" width="43.32" height="280.61" rx="15.08" ry="15.08" />
    <rect x="325.4" y="258.61" width="43.32" height="252.41" rx="15.31" ry="15.31" />
    <rect x="325.48" y="69.17" width="43.32" height="179.41" rx="15.85" ry="15.85" />
    <rect x="419.52" y="345.33" width="43.32" height="165.69" rx="15.7" ry="15.7" />
    <rect x="419.78" y="258.78" width="43.32" height="77.21" rx="15.44" ry="15.44" />
    <rect
      x="286.24"
      y="287.06"
      width="27.52"
      height="500"
      rx="13.76"
      ry="13.76"
      transform="translate(837.06 237.06) rotate(90)"
    />
  </svg>
</template>

<script>
export default {
  props: {
    changeColor: {
      required: true,
    },
  },
}
</script>

<style scoped lang="scss">
svg {
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);

  rect {
    fill: $white;
  }
  &.active rect {
    fill: $white;
  }
}

.light svg {
  rect {
    fill: $gray-6;
  }

  &.active rect {
    fill: $white;
  }
}
</style>
